/* eslint-disable no-constant-condition */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { withRouter, useHistory, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { useUser } from "../../core/context/user";
import { BoxIcon, CalendarRange, History, InfoIcon, ListIcon, MessageCircleQuestion, UserRoundPlus } from "lucide-react";
const Sidebar = (props) => {
  const [isSideMenu, setSideMenu] = useState("");
  const history = useHistory();
  const { isCurrentUserSuperAdmin, isUserLoggedIn, updateUser } = useUser();

  const toggleSidebar = (value) => {
    setSideMenu(value);
  };
  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };
  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };

  const check = (path) => {
    if (isCurrentUserSuperAdmin()) {
      return true;
    }
    if (path === "users") {
      return false;
    }
    return true;
  };

  const location = useLocation();
  let pathname = location.pathname;

  useEffect(() => {
    document.querySelector(".main-wrapper").classList.remove("slide-nav");
    document.querySelector(".sidebar-overlay").classList.remove("opened");
    document.querySelector(".sidebar-overlay").onclick = function () {
      this.classList.remove("opened");
      document.querySelector(".main-wrapper").classList.remove("slide-nav");
    };
  }, [pathname]);


  const logoutUser = () => {
    localStorage.clear();
    updateUser(null);
    history.push("/signIn");
  }

  return (
    <>
      <div
        className={`sidebar index-4 bg-white`}
        id="sidebar"
      >
        <div className="slimScrollDiv">
          <div className="sidebar-inner slimscroll">
            <div
              id="sidebar-menu"
              className="sidebar-menu"
              onMouseOver={expandMenuOpen}
              onMouseLeave={expandMenu}
            >
              <ul>
                <li className="submenu-open">
                  <h6 className="submenu-hdr">Main</h6>
                  <ul>
                    {check("dashboard") && (
                      <li
                        className={
                          pathname.includes("dashboard") ? "active" : ""
                        }
                      >
                        <Link to="/main/dashboard">
                          {/* <i data-feather="grid" /> */}
                          <FeatherIcon icon="grid" />
                          <span>Dashboard</span>
                        </Link>
                      </li>
                    )}

                    {check("appointments") && (
                      <li
                        className={
                          pathname.includes("appointments") ? "active" : ""
                        }
                      >
                        <Link
                          to="/main/appointments"
                          className={
                            pathname.includes("appointments") ? "active" : ""
                          }
                        >
                          <CalendarRange />
                          <span>Appointments</span>
                        </Link>
                      </li>
                    )}
                    {check("patients") && (
                      <li
                        className={
                          pathname.includes("patients") ? "active" : ""
                        }
                      >
                        <Link
                          to="/main/patients"
                          className={
                            pathname.includes("patients")
                              ? "active"
                              : ""
                          }
                        >
                          {/* <i data-feather="credit-card" /> */}
                          <UserRoundPlus />
                          <span>Patients</span>
                        </Link>
                      </li>
                    )}

                    {check("worklist") && (
                      <li
                        className={
                          pathname.includes("worklist") ? "active" : ""
                        }
                      >
                        <Link
                          to="/main/worklist"
                          className={
                            pathname.includes("worklist")
                              ? "active"
                              : ""
                          }
                        >
                          {/* <i data-feather="credit-card" /> */}
                          <ListIcon />
                          <span>Worklist</span>
                        </Link>
                      </li>
                    )}

                    {check("inventory") && (
                      <li
                        className={
                          pathname.includes("inventory") ? "active" : ""
                        }
                      >
                        <Link
                          to="/main/inventory"
                          className={
                            pathname.includes("inventory")
                              ? "active"
                              : ""
                          }
                        >
                          {/* <i data-feather="credit-card" /> */}
                          <BoxIcon />
                          <span>Inventory</span>
                        </Link>
                      </li>
                    )}

                    {check("contact-enquiries") && (
                      <li
                        className={
                          pathname.includes("contact-enquiries") ? "active" : ""
                        }
                      >
                        <Link
                          to="/main/contact-enquiries"
                          className={
                            pathname.includes("contact-enquiries") ? "active" : ""
                          }
                        >
                          {/* <i data-feather="credit-card" /> */}
                          <MessageCircleQuestion />
                          <span>Contact Enquiries</span>
                        </Link>
                      </li>
                    )}

                    {check("employees") && (
                      <li
                        className={pathname.includes("employees") ? "active" : ""}
                      >
                        <Link
                          className={
                            pathname.includes("employees") ? "active" : ""
                          }
                          to="/main/employees"
                        >
                          <FeatherIcon icon="users" />
                          <span>Employees</span>
                        </Link>
                      </li>
                    )}

                    {check("users") && (
                      <li
                        className={pathname.includes("users") ? "active" : ""}
                      >
                        <Link
                          className={
                            pathname.includes("users") ? "active" : ""
                          }
                          to="/main/users"
                        >
                          {/* <i data-feather="user-check" /> */}
                          <FeatherIcon icon="user-check" />
                          <span>Users</span>
                        </Link>
                      </li>
                    )}


                    {check("users") && (
                      <li
                        className={pathname.includes("history-logs") ? "active" : ""}
                      >
                        <Link
                          className={
                            pathname.includes("history-logs") ? "active" : ""
                          }
                          to="/main/history-logs"
                        >
                          {/* <i data-feather="user-check" /> */}
                          <History icon="user-check" />
                          <span>History Logs</span>
                        </Link>
                      </li>
                    )}




                    {check("reports") && (
                      <li
                        className={
                          pathname.includes("reports") ? "active" : ""
                        }
                      >
                        <Link
                          to="/main/reports"
                          className={
                            pathname.includes("reports") ? "active" : ""
                          }
                        >
                          {/* <i data-feather="credit-card" /> */}
                          <FeatherIcon icon="file-text" />
                          <span>Reports</span>
                        </Link>
                      </li>
                    )}




                    <li onClick={logoutUser}>
                      <Link
                        to="/signIn"
                        className={
                          pathname.includes("signIn") ? "active" : ""
                        }
                      >
                        <FeatherIcon icon="log-out" />
                        <span>Logout</span>{" "}
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(Sidebar);
